import SepoliaBitcoinRedeemer from "@acre-btc/contracts/deployments/sepolia/BitcoinRedeemer.json";
import MainnetBitcoinRedeemer from "@acre-btc/contracts/deployments/mainnet/BitcoinRedeemer.json";
import { EthersContractWrapper, } from "./contract";
export default class EthereumBitcoinRedeemer
// @ts-expect-error TODO: Figure out why type generated by typechain does not
// satisfy the constraint `Contract`. Error: `Property '[internal]' is missing
// in type 'BitcoinRedeemer' but required in type 'Contract'`.
 extends EthersContractWrapper {
    #cache;
    #tbtcBridge;
    constructor(config, network) {
        let artifact;
        switch (network) {
            case "sepolia":
                artifact = SepoliaBitcoinRedeemer;
                break;
            case "mainnet":
                artifact = MainnetBitcoinRedeemer;
                break;
            default:
                throw new Error("Unsupported network");
        }
        super(config, artifact);
        this.#cache = {
            tbtcBridgeRedemptionParameters: undefined,
        };
    }
    setTbtcContracts({ tbtcBridge }) {
        this.#tbtcBridge = tbtcBridge;
    }
    /**
     * @see {BitcoinRedeemer#getChainIdentifier}
     */
    getChainIdentifier() {
        return this.getAddress();
    }
    /**
     * @see {BitcoinRedeemer#calculateWithdrawalFee}
     */
    async calculateWithdrawalFee(amountToWithdraw) {
        const { redemptionTreasuryFeeDivisor } = await this.#getTbtcBridgeRedemptionParameters();
        const treasuryFee = redemptionTreasuryFeeDivisor > 0
            ? amountToWithdraw / redemptionTreasuryFeeDivisor
            : 0n;
        return {
            tbtc: {
                treasuryFee,
            },
        };
    }
    // TODO: Consider exposing it from tBTC SDK.
    async #getTbtcBridgeRedemptionParameters() {
        if (this.#cache.tbtcBridgeRedemptionParameters) {
            return this.#cache.tbtcBridgeRedemptionParameters;
        }
        if (!this.#tbtcBridge) {
            throw new Error("tBTC contracts not set");
        }
        const { redemptionTreasuryFeeDivisor } = await this.#tbtcBridge.redemptionParameters();
        this.#cache.tbtcBridgeRedemptionParameters = {
            redemptionTreasuryFeeDivisor,
        };
        return this.#cache.tbtcBridgeRedemptionParameters;
    }
}
//# sourceMappingURL=bitcoin-redeemer.js.map